<template>
    <div :class="{'min-h-full flex': true, 'flex-col': isLoggedIn, 'bg-white': !isLoggedIn}">
        <template v-if="isLoggedIn">
            <NavigationComponent @open-create-gallery="openCreateGalley" />

            <div v-if="$route.name === 'user.subscription.thank_you'" class="h-full w-full mx-auto my-auto">
                <router-view />
            </div>

            <div v-else-if="$route.name === '404'" class="h-full w-full mx-auto my-auto">
                <router-view />
            </div>

            <main v-else class="pt-10 sm:pt-16">
                <div class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                    <router-view />
                </div>
            </main>

            <div class="mt-auto mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                <div class="w-full">
                    <div class="inline-flex justify-between w-full items-center">
                        <p class="text-sm font-medium text-gray-600">Gallera &copy; 2025</p>

                        <div class="inline-flex gap-3 items-center">
                            <a href="#" @click.prevent="switchLocale" class="text-sm text-gray-500 flex items-center gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="shrink-0 size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
                                </svg>

                                <span>{{ $i18n.locale === 'en' ? 'Українська' : 'English' }}</span>
                            </a>
                            <a href="https://t.me/galleraio" target="_blank" class="text-sm text-gray-500">
                                <svg class="shrink-0 size-6" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.3749 16.9956C14.7436 14.7024 18.3236 13.1905 20.1148 12.4601C25.2292 10.3745 26.2919 10.0122 26.9846 10.0001C27.1369 9.99761 27.4776 10.0346 27.6982 10.2102C27.8845 10.3584 27.9358 10.5586 27.9603 10.6991C27.9848 10.8397 28.0154 11.1598 27.9911 11.4099C27.714 14.2649 26.5147 21.1932 25.9046 24.3908C25.6465 25.7439 25.1382 26.1976 24.6461 26.2419C23.5766 26.3384 22.7645 25.549 21.7287 24.8833C20.1078 23.8416 19.1921 23.1932 17.6188 22.1767C15.8005 21.002 16.9792 20.3563 18.0154 19.3011C18.2866 19.025 22.9987 14.823 23.0899 14.4418C23.1013 14.3941 23.1119 14.2164 23.0042 14.1225C22.8965 14.0287 22.7376 14.0608 22.6229 14.0863C22.4604 14.1225 19.871 15.8004 14.8549 19.1201C14.1199 19.6149 13.4542 19.856 12.8577 19.8434C12.2001 19.8295 10.9353 19.4789 9.99498 19.1792C8.84166 18.8117 7.92503 18.6173 8.00485 17.9931C8.04642 17.668 8.5031 17.3355 9.3749 16.9956Z" fill="#505C75"></path>
                                </svg>
                            </a>
                            <a href="https://instagram.com/gallera.io" target="_blank" class="text-sm text-gray-500">
                                <svg class="shrink-0 size-6" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 9.80723C20.6506 9.80723 21.0121 9.80723 22.0964 9.80723C23.0602 9.80723 23.5422 10.0482 23.9036 10.1687C24.3855 10.4096 24.747 10.5301 25.1084 10.8916C25.4699 11.253 25.7108 11.6145 25.8313 12.0964C25.9518 12.4578 26.0723 12.9398 26.1928 13.9036C26.1928 14.988 26.1928 15.2289 26.1928 18C26.1928 20.7711 26.1928 21.0121 26.1928 22.0964C26.1928 23.0602 25.9518 23.5422 25.8313 23.9036C25.5904 24.3855 25.4699 24.747 25.1084 25.1084C24.747 25.4699 24.3855 25.7108 23.9036 25.8313C23.5422 25.9518 23.0602 26.0723 22.0964 26.1928C21.0121 26.1928 20.7711 26.1928 18 26.1928C15.2289 26.1928 14.988 26.1928 13.9036 26.1928C12.9398 26.1928 12.4578 25.9518 12.0964 25.8313C11.6145 25.5904 11.253 25.4699 10.8916 25.1084C10.5301 24.747 10.2892 24.3855 10.1687 23.9036C10.0482 23.5422 9.92771 23.0602 9.80723 22.0964C9.80723 21.0121 9.80723 20.7711 9.80723 18C9.80723 15.2289 9.80723 14.988 9.80723 13.9036C9.80723 12.9398 10.0482 12.4578 10.1687 12.0964C10.4096 11.6145 10.5301 11.253 10.8916 10.8916C11.253 10.5301 11.6145 10.2892 12.0964 10.1687C12.4578 10.0482 12.9398 9.92771 13.9036 9.80723C14.988 9.80723 15.3494 9.80723 18 9.80723ZM18 8C15.2289 8 14.988 8 13.9036 8C12.8193 8 12.0964 8.24096 11.494 8.48193C10.8916 8.72289 10.2892 9.08434 9.68675 9.68675C9.08434 10.2892 8.84337 10.7711 8.48193 11.494C8.24096 12.0964 8.12048 12.8193 8 13.9036C8 14.988 8 15.3494 8 18C8 20.7711 8 21.0121 8 22.0964C8 23.1807 8.24096 23.9036 8.48193 24.506C8.72289 25.1084 9.08434 25.7108 9.68675 26.3133C10.2892 26.9157 10.7711 27.1566 11.494 27.5181C12.0964 27.759 12.8193 27.8795 13.9036 28C14.988 28 15.3494 28 18 28C20.6506 28 21.0121 28 22.0964 28C23.1807 28 23.9036 27.759 24.506 27.5181C25.1084 27.2771 25.7108 26.9157 26.3133 26.3133C26.9157 25.7108 27.1566 25.2289 27.5181 24.506C27.759 23.9036 27.8795 23.1807 28 22.0964C28 21.0121 28 20.6506 28 18C28 15.3494 28 14.988 28 13.9036C28 12.8193 27.759 12.0964 27.5181 11.494C27.2771 10.8916 26.9157 10.2892 26.3133 9.68675C25.7108 9.08434 25.2289 8.84337 24.506 8.48193C23.9036 8.24096 23.1807 8.12048 22.0964 8C21.0121 8 20.7711 8 18 8Z" fill="#505C75"></path>
                                    <path d="M18 12.8193C15.1084 12.8193 12.8193 15.1084 12.8193 18C12.8193 20.8916 15.1084 23.1807 18 23.1807C20.8916 23.1807 23.1807 20.8916 23.1807 18C23.1807 15.1084 20.8916 12.8193 18 12.8193ZM18 21.3735C16.1928 21.3735 14.6265 19.9277 14.6265 18C14.6265 16.1928 16.0723 14.6265 18 14.6265C19.8072 14.6265 21.3735 16.0723 21.3735 18C21.3735 19.8072 19.8072 21.3735 18 21.3735Z" fill="#505C75"></path>
                                    <path d="M23.3012 13.9036C23.9666 13.9036 24.506 13.3642 24.506 12.6988C24.506 12.0334 23.9666 11.494 23.3012 11.494C22.6358 11.494 22.0964 12.0334 22.0964 12.6988C22.0964 13.3642 22.6358 13.9036 23.3012 13.9036Z" fill="#505C75"></path>
                                </svg>
                            </a>
                            <a :href="publicUrl('contacts')" target="_blank" class="text-sm text-gray-500">{{ $t('app.contacts') }}</a>
                            <a :href="$i18n.locale === 'en' ? 'https://help.gallera.io/?lang=en' : 'https://help.gallera.io/'" target="_blank" class="text-sm text-gray-500">{{ $t('app.help') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="!isLoggedIn">
            <div class="relative z-10 flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24 lg:shadow-[20px_0_40px_-10px_rgba(0,0,0,0.3)]">
                <router-view />
            </div>
            <div class="relative hidden w-0 flex-1 lg:block">
                <img class="absolute inset-0 size-full object-cover object-right" src="@/assets/images/site-example.png" alt="Gallera">
            </div>
        </template>
    </div>

    <CreateGalleryComponent v-if="isLoggedIn" :open="createGalleryOpen" @close="createGalleryOpen = false" />

    <AlertsComponent />

    <NotificationManagerComponent v-if="isLoggedIn" />
    <NewFeatureToastComponent
        v-if="isLoggedIn && $route.name === 'galleries.photos'"
        :is-visible="showNewFeatureToast"
        @dismiss="dismissNewFeatureToast"
    />
    <GlobalUploadProgressComponent v-if="isLoggedIn" />
</template>

<script lang="ts">
import {defineComponent} from 'vue';

import NavigationComponent from '@/components/Layout/NavigationComponent.vue'
import AlertsComponent from "@/components/AlertsComponent.vue";
import CreateGalleryComponent from "@/components/Galleries/CreateGalleryComponent.vue";
import NotificationManagerComponent from "@/components/Notifications/NotificationManagerComponent.vue";
import NewFeatureToastComponent from "@/components/Galleries/NewFeatureToastComponent.vue";
import GlobalUploadProgressComponent from "@/components/GlobalUploadProgressComponent.vue";
import {mapGetters} from "vuex";

export default defineComponent({
    name: 'App',
    components: {
        CreateGalleryComponent,
        NavigationComponent,
        AlertsComponent,
        NotificationManagerComponent,
        NewFeatureToastComponent,
        GlobalUploadProgressComponent,
    },

    data: function () {
        return {
            createGalleryOpen: false,
            showNewFeatureToast: false as boolean,
        }
    },

    computed: {
        ...mapGetters({
            isLoggedIn: 'user/isLoggedIn',
            user: 'user/user',
            isUploading: 'upload/isUploading',
        }),
    },

    mounted() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);

        // Перевіряємо при першому завантаженні
        if (this.$route.name === 'galleries.photos') {
            this.checkAndShowNewFeatureToast();
        }
    },

    beforeUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },

    watch: {
        '$route'(to) {
            if (to.name === 'galleries.photos') {
                this.checkAndShowNewFeatureToast();
            }
        }
    },

    methods: {
        handleBeforeUnload(event: BeforeUnloadEvent) {
            if (this.isUploading) {
                const message = this.$t('photo_uploader.unload_warning') as string;
                event.returnValue = message;
                return message;
            }
        },

        openCreateGalley() {
            this.createGalleryOpen = true;
        },

        publicUrl(url: string): string {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },

        switchLocale() {
            const currentLocale = this.$i18n.locale;
            const newLocale = currentLocale === 'en' ? 'uk' : 'en';
            this.$i18n.locale = newLocale;
            localStorage.setItem('locale', newLocale);

            location.reload();
        },

        checkAndShowNewFeatureToast() {
            // Перевіряємо, чи користувач вже бачив сповіщення про новий функціонал
            const hasSeenNotification = localStorage.getItem('new-feature-notification-seen');
            if (!hasSeenNotification) {
                (this as any).showNewFeatureToast = true;
            }
        },

        dismissNewFeatureToast() {
            (this as any).showNewFeatureToast = false;
            localStorage.setItem('new-feature-notification-seen', 'true');
        },
    },
});
</script>

<style src="./assets/css/app.css" />